export function expandRecursive(node, isExpand) {
  node.expanded = isExpand;
  if (node.children) {
    node.children.forEach(childNode => {
      expandRecursive(childNode, isExpand);
    });
  }
}
export function findTreeNodeBy(nodes, matcher, matchBy) {
  return nodes.find(n => n[matchBy] === matcher);
}
export function deepFindTreeNodeBy(nodes, matchFn) {
  const path = getPathToMatchingTreeNode(nodes, matchFn);
  if (path) return path[path.length - 1];else return null;
}
export function getPathToMatchingTreeNode(nodes, matchFn) {
  const match = nodes.find(matchFn);
  if (match) return [match];
  for (const n of nodes) {
    if (n.children?.length) {
      const deepMatch = getPathToMatchingTreeNode(n.children, matchFn);
      if (deepMatch) return [n, ...deepMatch];
    }
  }
  return null;
}
export function getTreeNodePath(rootNodes, path, matchBy) {
  const collection = [];
  let node;
  let currentNodes = rootNodes;
  for (let depth = 0; depth < path.length; depth++) {
    node = findTreeNodeBy(currentNodes, path[depth], matchBy);
    if (node) {
      collection.push(node);
      currentNodes = node.children || [];
    } else {
      break;
    }
  }
  return collection;
}